import { colors } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { Typography } from "../../../Typography";

export type ActionProps = {
	label: string;
	disabled?: boolean;
	selected?: boolean;
};

const styles = stylex.create({
	root: {
		alignSelf: "center",
		textAlign: "center",
	},
	default: {
		color: colors.accentTxtDefault,
	},
	disabled: {
		color: colors.disabledTxtDefault,
	},
	selected: {
		color: colors.neutralTxtInverted,
	},
});

export const Action = ({ label, disabled, selected }: ActionProps) => {
	return (
		<Typography.LabelDefault
			render={<span />}
			sx={[styles.root, disabled ? styles.disabled : styles.default, selected && styles.selected]}
		>
			{label}
		</Typography.LabelDefault>
	);
};
